/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentEditorViewModel } from "../types/IndividualPaymentEditorViewModel.ts";
import { individualPaymentCouponHistoryViewModelSchema } from "./individualPaymentCouponHistoryViewModelSchema.ts";
import { individualPaymentEditorAddressViewModelSchema } from "./individualPaymentEditorAddressViewModelSchema.ts";
import { individualPaymentEditorCouponViewModelSchema } from "./individualPaymentEditorCouponViewModelSchema.ts";
import { individualPaymentEditorCourseFinancialViewModelSchema } from "./individualPaymentEditorCourseFinancialViewModelSchema.ts";
import { individualPaymentEditorDiscountViewModelSchema } from "./individualPaymentEditorDiscountViewModelSchema.ts";

export const individualPaymentEditorViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  courseRegistrationCompanyId: z.number().int().nullish(),
  type: z.optional(z.number().int()),
  typeText: z.string().nullish(),
  status: z.optional(z.number().int()),
  statusText: z.string().nullish(),
  description: z.string().nullish(),
  additionalInformation: z.string().nullish(),
  mainFinancialRenegotiation: z.number().int().nullish(),
  email: z.string().nullish(),
  courseName: z.string().nullish(),
  discountPunctualPercentage: z.optional(z.number()),
  expirationDate: z.optional(z.number().int()),
  scholarshipStatus: z.number().int().nullish(),
  automaticGenerateInvoice: z.optional(z.boolean()),
  customerIntegrationDate: z.string().datetime().nullish(),
  numberParcels: z.optional(z.number().int()),
  totalValue: z.optional(z.number()),
  totalValueWithoutValueTransfer: z.optional(z.number()),
  valueTransfer: z.optional(z.number()),
  valueRegistration: z.optional(z.number()),
  student: z.string().nullish(),
  financialAssociatedCompanyId: z.number().int().nullish(),
  isAssociatedDetailsFromFinancial: z.optional(z.boolean()),
  cnpj: z.string().nullish(),
  ie: z.string().nullish(),
  ieFree: z.optional(z.boolean()),
  payAsCompany: z.optional(z.boolean()),
  observation: z.string().nullish(),
  companyName: z.string().nullish(),
  companyContactName: z.string().nullish(),
  companyContactEmail: z.string().nullish(),
  companyContactPhone: z.string().nullish(),
  countryCodeCompanyContact: z.string().nullish(),
  paymentMethod: z.optional(z.number().int()),
  paymentMethodText: z.string().nullish(),
  discountScholarshipPercentage: z.number().nullish(),
  countryCodeThirdPhone: z.string().nullish(),
  thirdPhone: z.string().nullish(),
  thirdDocument: z.string().nullish(),
  thirdEmail: z.string().nullish(),
  thirdName: z.string().nullish(),
  thirdPayment: z.optional(z.boolean()),
  thirdCode: z.string().nullish(),
  enrollmentStatus: z.optional(z.number().int()),
  paymentReceiptType: z.number().int().nullish(),
  courseFinancialId: z.optional(z.number().int()),
  courseRegistrationId: z.optional(z.number().int()),
  personId: z.optional(z.number().int()),
  scholarshipTypeId: z.number().int().nullish(),
  scholarshipReason: z.string().nullish(),
  courseFinancial: z.optional(
    z.lazy(() => individualPaymentEditorCourseFinancialViewModelSchema),
  ),
  discounts: z
    .array(z.lazy(() => individualPaymentEditorDiscountViewModelSchema))
    .nullish(),
  hasEnrollmentParcel: z.optional(z.boolean()),
  creationDate: z.string().datetime().nullish(),
  lastChangeDate: z.string().datetime().nullish(),
  userNameCreator: z.string().nullish(),
  userNameLastChange: z.string().nullish(),
  couponCourseFinPerson: z.optional(
    z.lazy(() => individualPaymentEditorCouponViewModelSchema),
  ),
  discountReferralAmount: z.number().nullish(),
  hidePaymentPlan: z.optional(z.boolean()),
  couponsHistory: z
    .array(z.lazy(() => individualPaymentCouponHistoryViewModelSchema))
    .nullish(),
  totalPaidWithoutRetroactive: z.optional(z.number()),
  closedParcels: z.optional(z.number().int()),
  lastCreditCard: z.string().nullish(),
  thirdAddress: z.optional(
    z.lazy(() => individualPaymentEditorAddressViewModelSchema),
  ),
  readMonthValue: z.optional(z.number()),
  readMonthValueWithDiscount: z.optional(z.number()),
  readMonthValueWithDiscountAndPunctual: z.optional(z.number()),
  readTotalDiscount: z.optional(z.number()),
  readTotalDiscountWithPunctual: z.optional(z.number()),
  readTotalValueWithDiscount: z.optional(z.number()),
  readTotalValueWithDiscountAndPunctual: z.optional(z.number()),
  readTotalDiscountPercentage: z.optional(z.number()),
  readTotalDiscountPercentageWithPunctual: z.optional(z.number()),
}) as unknown as ToZod<IndividualPaymentEditorViewModel>;
